export const white = "#ffffff";
export const accent = "#ff4f1e"
export const primary = "#0aa89e";
export const error = "#F00";